<template>
  <!-- The shell's overlays over the pane: the Settings window (pointer
       density, 700 px and up; SI-9), the Inbox sheet, the sound and
       session sheets, the shortcuts sheet and the account menu. Esc, the
       backdrop and ✕ close the window; closing goes back to the pane. -->
  <div v-if="overlay === 'settings'" class="settings-scrim" @click.self="close">
    <SettingsView presentation="window" @close="close" />
  </div>
  <InboxSheet v-if="overlay === 'inbox'" @close="close" />
  <SoundSheetsHost />
  <SessionSheetsHost />
  <ShortcutsSheet v-model="shortcutsOpen" />
  <AccountMenu />
</template>

<script>
import { defineAsyncComponent } from "vue";
import SoundSheetsHost from "./SoundSheetsHost.vue";
import SessionSheetsHost from "./SessionSheetsHost.vue";
import ShortcutsSheet from "./ShortcutsSheet.vue";
import AccountMenu from "./AccountMenu.vue";
import { overlayKind, shellState } from "./shellState.js";
import { setShortcutEnv } from "./shortcuts.js";
import { alertState, closeAlert } from "./confirm.js";
import { viewport } from "./sizeClass.js";

export default {
  name: "OverlayHost",
  components: {
    SoundSheetsHost,
    SessionSheetsHost,
    ShortcutsSheet,
    AccountMenu,
    SettingsView: defineAsyncComponent(() => import("@/views/Settings.vue")),
    InboxSheet: defineAsyncComponent(() => import("@/components/social/InboxSheet.vue")),
  },
  data: () => ({ shortcutsOpen: false }),
  computed: {
    // Overlays read the real route (paneRoute.js).
    overlay() {
      return overlayKind(this.$route, { density: shellState.density, width: viewport.width });
    },
  },
  mounted() {
    setShortcutEnv({
      openShortcuts: () => (this.shortcutsOpen = true),
      // The pane's keys wait while any of these is up (M2).
      overlayOpen: () => alertState.open || this.shortcutsOpen || !!this.overlay,
      closeOverlay: () => {
        if (alertState.open) {
          closeAlert(alertState.dismiss);
          return true;
        }
        if (this.shortcutsOpen) {
          this.shortcutsOpen = false;
          return true;
        }
        if (this.overlay) {
          this.close();
          return true;
        }
        return false;
      },
    });
  },
  methods: {
    close() {
      this.$router.push(shellState.lastPane || "/sessions/mine").catch(() => {});
    },
  },
};
</script>

<style scoped>
.settings-scrim {
  position: fixed;
  inset: 0;
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--cl-scrim);
}
</style>
